import { render } from "./ProcedenciaCreate.vue?vue&type=template&id=7a343b58&scoped=true"
import script from "./ProcedenciaCreate.vue?vue&type=script&lang=js"
export * from "./ProcedenciaCreate.vue?vue&type=script&lang=js"

import "./ProcedenciaCreate.vue?vue&type=style&index=0&id=7a343b58&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a343b58"]])

export default __exports__